import React from 'react';
import styled, { css } from 'styled-components';

/**
 * Applies as style to a component allowing it to be escape the disabled
 * layer created by DisableChildren.
 * IF targeting a component wrapped by your component - make sure
 * it is passing the className prop all the way down.
 * @param Component
 * @param zIndex - if you changed the default zIndex of DisableChildren
 * then pass that value here.
 * @returns
 */
export const enableChild = <P>(
  Component: React.ComponentType<P>,
  zIndex = 1,
  position = 'relative',
) => {
  const EnabledComponent = styled(Component)`
    ${() => css`
      z-index: ${zIndex + 1};
      pointer-events: auto;
      position: ${position};
    `}
  `;
  return EnabledComponent;
};

export default enableChild;
